import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { CurriculumOverview } from '../components/CurriculumOverview';
import { CourseGrid } from '../components/CourseGrid';
import { SpeakersSection } from '../components/SpeakersSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { CurriculumPopup } from '../components/CurriculumPopup';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-[#59d0d4]/30 selection:text-[#3b7780]" data-id="element-536">
      <Navbar data-id="element-537" />
      <main data-id="element-538">
        <HeroSection data-id="element-539" />
        <AboutSection data-id="element-540" />
        <CurriculumOverview data-id="element-541" />
        <CourseGrid data-id="element-542" />
        <SpeakersSection data-id="element-543" />
        <TestimonialsSection data-id="element-544" />
        <CTASection data-id="element-545" />
      </main>
      <Footer data-id="element-546" />
      <CookieBanner data-id="element-547" />
      <CurriculumPopup data-id="element-548" />
    </div>;
}